import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreatePermitDepartmentPayload, GetPermitDepartmentsParams, PermitDepartment, UpdatePermitDepartmentPayload } from '../models/permit-department.model';

@Injectable()
export class PermitDepartmentService {
    private readonly baseUrl = `${environment.API_GATEWAY_URL}/permit/admin/permit-department`;

    constructor(private http: HttpClient) {}

    getDepartments(params?: GetPermitDepartmentsParams): Observable<PermitDepartment[]> {
        let httpParams = new HttpParams();
        if (params?.search) httpParams = httpParams.set('search', params.search);
        if (params?.includeInactive !== undefined) httpParams = httpParams.set('includeInactive', String(params.includeInactive));
        return this.http.get<PermitDepartment[]>(this.baseUrl, { params: httpParams });
    }

    getDepartmentById(id: string): Observable<PermitDepartment> {
        return this.http.get<PermitDepartment>(`${this.baseUrl}/${id}`);
    }

    createDepartment(payload: CreatePermitDepartmentPayload): Observable<PermitDepartment> {
        return this.http.post<PermitDepartment>(this.baseUrl, this.normalizeManagers(payload));
    }

    updateDepartment(id: string, payload: UpdatePermitDepartmentPayload): Observable<PermitDepartment> {
        return this.http.patch<PermitDepartment>(`${this.baseUrl}/${id}`, this.normalizeManagers(payload));
    }

    /** DELETE archives (isActive=false); 400 permit-department.has-active-types while active types route here. */
    archiveDepartment(id: string): Observable<PermitDepartment> {
        return this.http.delete<PermitDepartment>(`${this.baseUrl}/${id}`);
    }

    unarchiveDepartment(id: string): Observable<PermitDepartment> {
        return this.updateDepartment(id, { isActive: true });
    }

    // Managers may arrive as populated objects; the API expects string ids.
    private normalizeManagers<T extends UpdatePermitDepartmentPayload>(payload: T): T {
        if (!payload.managers || !Array.isArray(payload.managers)) return payload;
        return {
            ...payload,
            managers: payload.managers.map((m) => (typeof m === 'string' ? m : m?._id || '')).filter((id) => id),
        };
    }
}
